import React, { useState, useEffect } from "react";
import styles from "../../styles/GenericTable.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons/faChevronLeft";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons/faChevronRight";

function filterPages(visiblePages, totalPages) {
  return visiblePages.filter((page) => page <= totalPages);
}

function getVisiblePages(page, total) {
  if (total < 7) {
    return filterPages([1, 2, 3, 4, 5, 6], total);
  } else {
    if (page % 5 >= 0 && page > 4 && page + 2 < total) {
      return [1, page - 1, page, page + 1, total];
    } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
      return [1, total - 3, total - 2, total - 1, total];
    } else {
      return [1, 2, 3, 4, 5, total];
    }
  }
}

export default function Pagination(props) {
  const {
    tablePaginationProps,
    canPreviousPage,
    nextPage,
    canNextPage,
    pageCount,
    gotoPage,
    pageIndex,
    pageOptions,
    setPageSize,
    previousPage,
    pageSize,
    scrollOption
  } = props;

  const [visiblePages, setVisiblePages] = useState(
    getVisiblePages(null, pageOptions.length)
  );
  const [activePage, setActivePage] = useState(pageIndex + 1);
  const PageButton = (props) => <button {...props}>{props.children}</button>;

  function handleNextPage() {
    if(scrollOption) window.scrollTo({ top: 0, behavior: "smooth" });
    nextPage();
  }
  function handlePreviousPage() {
    if(scrollOption) window.scrollTo({ top: 0, behavior: "smooth" });
    previousPage();
  }

  function changePage(page) {
    if (page === activePage) {
      return;
    }
    setVisiblePages(getVisiblePages(page, pageOptions.length));
    setActivePage(page);
    gotoPage(page - 1);
    if(scrollOption) window.scrollTo({ top: 0, behavior: "smooth" });
  }

  const PaginationButtons = () => {
    return visiblePages.map((page, index, array) => {
      return (
        <PageButton
          key={page}
          className={
            activePage === page
              ? styles.paginationNumberBtnActive
              : styles.paginationNumberBtn
          }
          onClick={() => changePage(page)}
        >
          {array[index - 1] + 2 < page ? `...${page}` : page}
        </PageButton>
      );
    });
  };

  useEffect(() => {
    setActivePage(pageIndex + 1);

    setVisiblePages(getVisiblePages(activePage, pageOptions.length));
  }, [activePage, pageOptions, pageIndex]);
  return (
    <div className={styles.paginationWrapper}>
      {tablePaginationProps.showSkipToBeginning && (
        <button
          onClick={() => changePage(0)}
          disabled={!canPreviousPage}
          className={styles.paginationNavBtn}
        >
          <FontAwesomeIcon icon={faChevronLeft} />
          <FontAwesomeIcon icon={faChevronLeft} />
        </button>
      )}
      <button
        onClick={() => handlePreviousPage()}
        disabled={!canPreviousPage}
        className={styles.paginationNavBtn}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
        <span>Previous</span>
      </button>
      {PaginationButtons()}
      <button
        onClick={() => handleNextPage()}
        disabled={!canNextPage}
        className={styles.paginationNavBtn}
      >
        <span>Next</span>
        <FontAwesomeIcon icon={faChevronRight} />
      </button>
      {tablePaginationProps.showSkipToEnd && (
        <button
          onClick={() => changePage(pageCount - 1)}
          disabled={!canNextPage}
          className={styles.paginationNavBtn}
        >
          <FontAwesomeIcon icon={faChevronRight} />
          <FontAwesomeIcon icon={faChevronRight} />
        </button>
      )}
      <div className={styles.pageOf}>
        <span className={styles.pageOfLabel}>Page: </span>
        <strong>
          {pageCount > 0 ? pageIndex + 1 : 0} of {pageOptions.length}
        </strong>
      </div>
      {tablePaginationProps.showGoToPage && (
        <span>
          | Go to page:
          <input
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: "70px", height: "30px" }}
          />
        </span>
      )}

      {tablePaginationProps.showPageSizeDropdown && (
        <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[10, 20, 30, 40, 50].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
